import {
  MdsDropdownButton,
  MdsDropdownButtonProps,
} from "@/design-system/components/dropdown/MdsDropdownButton";
import { MdsIconKind } from "@/design-system/components/icon";
import styled from "@emotion/styled";

export const SortDropdownButton = ({
  isToggled,
  ...props
}: MdsDropdownButtonProps & { isToggled?: boolean }) => {
  return (
    <StyledSortDropdownButton iconKind={MdsIconKind.SortAlt} {...props} $isToggled={isToggled} />
  );
};

const StyledSortDropdownButton = styled(MdsDropdownButton)<{ $isToggled?: boolean }>`
  .mds-button {
    height: auto;
    color: ${({ theme, $isToggled }) =>
      $isToggled ? theme.colors.text.emphasis : theme.colors.text.tertiary};
    background-color: ${({ theme, $isToggled }) =>
      $isToggled
        ? theme.colors.background.button.toggle.toggled
        : theme.colors.background.button.toggle.default};
    padding: ${({ theme }) => theme.spacing["2"]} ${({ theme }) => theme.spacing["3"]};
    border: none;

    &[data-hovered]:not([data-disabled]) {
      background-color: ${({ theme, $isToggled }) =>
        $isToggled
          ? theme.colors.background.button.toggle.toggledHover
          : theme.colors.background.button.toggle.hover};
    }

    & .mds-icon {
      color: ${({ theme, $isToggled }) =>
        $isToggled ? theme.colors.icon.selected : theme.colors.icon.placeholder};
    }
  }
`;
